<template>
  <div>
    <ValidationObserver ref="formValidator">
      <form novalidate @submit.prevent="save">
        <div v-if="subAreaOptions.length == 0" class="row">
          <div class="col-12">
            <label>{{ `${isEditing ? 'Editar' : 'Añadir'} Meta:` }}</label>
          </div>
        </div>

        <div v-else class="row">
          <div class="col-12">
            <label>Sub-Áreas:</label>
          </div>
          <div class="col-12">
            <Error
              v-if="subAreaOptions.length > 0 && selectedSubAreas.length <= 0"
              :message="validationMessages[2]"
            />

            <ValidationProvider
              v-slot="{ errors }"
              class="w-100"
              rules="required"
              name="Sub-Área"
            >
              <CustomDropDown
                v-model="selectedSubArea"
                placeholder="Seleccione"
                required
                fieldkey="id"
                fieldname="name"
                :options="selectedSubAreas"
                :error="errors[0]"
                :custom-error-msg="validationMessages[1]"
              />
            </ValidationProvider>
          </div>
        </div>

        <div class="row">
          <div class="col-12">
            <ValidationProvider
              v-slot="{ errors }"
              rules="required"
              name="descripción"
            >
              <CustomTextarea
                v-model="description"
                class="mt-3"
                required
                :custom-error-msg.sync="errors[0]"
                :error="errors[0]"
                :maxlength="500"
              />
            </ValidationProvider>
          </div>
        </div>

        <div class="row" v-if="showAdequacy">
          <AdequacyForm
            v-model="adequacyData"
            :adequacy-options="adequacyOptions"
          />
        </div>

        <ValidationProvider
          v-slot="{ errors }"
          :rules="skillsRequired && !selectedStrengthOrNecessity.length ? 'required':''"
          name="las necesidades y/o fortalezas"
        > 
          <CustomMultiSelect
            label="Fortalezas / Necesidades:"
            class="mt-3"
            :error-message="errors[0]"
            :options="necessityOptions"
            v-model="selectedStrengthOrNecessity"
          />
          <NecessityStrengthGoalList
            class="px-4"
            v-if="selectedStrengthOrNecessity?.length > 0"
            :list="selectedStrengthOrNecessity"
            @delete="handleDeleteNec($event)"
          />
        </ValidationProvider>

        <div class="row mt-3">
          <div class="col-12">
            <Error
              is-alert-mode
              message="Las metas de los estudiantes debe de cumplir al menos con los siguientes componentes: Término, Persona, Acción y Adecuacidad."
            />
          </div>
        </div>

        <div class="text-right">
          <ActionButton
            i="fas fa-times-circle"
            variant="outline-danger m-2"
            @click="cancelGoal"
          >
            Cancelar
          </ActionButton>
          <ActionButton
            i="fas fa-save"
            variant="success m-2"
            :type="'submmit'"
          >
            Guardar
          </ActionButton>
        </div>
      </form>
    </ValidationObserver>
  </div>
</template>

<script>
import { ValidationProvider, ValidationObserver, extend } from 'vee-validate';
import * as rules from 'vee-validate/dist/rules';
import { messages } from '@/components/pei/programservice/goals/locales/es.json';
import alert from '@/mixin/alert.mixin';
import ActionButton from '@/components/common/ActionButton';
import CustomTextarea from '@/components/common/CustomTextArea';
import CustomDropDown from '@/components/common/CustomDropDown.vue';
import Error from '@/components/common/Error';
import { CustomMultiSelect } from '@/components/common';
import NecessityStrengthGoalList from '../NecessityStrengthGoalList';
import AdequacyForm from '../v2/adequacy/AdequacyForm.vue';
import { BuildAdequacyText, FirstLetterToUpperCase } from '../v2/common/Helper.js';

export default {
  name: 'GoalForm',
  mixins: [alert],
  components: {
    ActionButton,
    CustomTextarea,
    CustomDropDown,
    Error,
    ValidationProvider,
    ValidationObserver,
    CustomMultiSelect,
    NecessityStrengthGoalList,
    AdequacyForm
  },
  data() {
    return {
      skillsUpdated: false,
      addObjectives: false,
      currentObjective: '',
      description: '',
      isEditingObjective: false,
      currentGoal: '',
      selectedSubArea: null,
      selectedStrengthOrNecessity: [],
      validationMessages: {
        1: 'Favor de seleccionar la sub-área a la que se dirige la meta.',
        2: 'Para documentar la meta es requerido primero realizar la selección de sub-áreas.',
      },
      adequacyData: {
        adequacy: null,
        measure1Amt: null,
        measure2Amt: null,
      }
    };
  },
  props: {
    goal: {
      type: Object,
      default: null,
    },
    areaId: {
      type: Number,
      default: 0,
    },
    necessityOptions: {
      type: Array,
      default: null,
    },
    programServiceAreaId: {
      type: Number,
      default: 0,
    },
    peiId: {
      type: String,
      default: '',
    },
    isEditing: {
      type: Boolean,
      default: false,
    },
    subAreaOptions: {
      type: Array,
      default: () => []
    },    
    selectedSubAreas: {
      type: Array,
      default: () => []
    },
    skillsRequired: {
      type: Boolean,
      default: true
    },
    adequacyOptions: {
      type: Array,
      default: () => ([])
    },
    showAdequacy: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    handleDeleteNec(item) {
      if (!item) return;

      this.selectedStrengthOrNecessity.splice(this.selectedStrengthOrNecessity.indexOf(item), 1);
    },
    cancelGoal: function() {
      this.description = '';
      this.$emit('cancel-goal');
    },
    async save() {
      const isValid = await this.$refs.formValidator.validate();
      if (!isValid) return isValid;
      
      const goal = {
        peiProgramServiceGoalId: this.currentGoal.peiProgramServiceGoalId
          ? this.currentGoal.peiProgramServiceGoalId
          : 0,
        description: this.completeDescription,
        spaShortDescription: this.completeDescription,
        spaLongDescription: this.completeDescription,
        peiProgramServiceObjective: !this.currentGoal
          .peiProgramServiceObjective
          ? []
          : this.currentGoal.peiProgramServiceObjective,
        programServiceAreaId: parseInt(this.programServiceAreaId),
        areaId: this.areaId,
        goalId:
          this.currentGoal.goalId && this.currentGoal.goalId > 0
            ? this.currentGoal.goalId
            : this.areaId,
        peiId: this.peiId,
        subAreaId: this.selectedSubArea ? this.selectedSubArea.id : null,
        strenghtsAndNecessities: this.selectedStrengthOrNecessity,
      };
      
      if (!this.currentGoal.peiProgramServiceGoalId) {
        this.$emit('create-goal', goal);
        return isValid;
      }
      
      this.$emit('update-goal', goal);
      return isValid;
    },
    // Loads the object in memory to be edited.
    loadEditing() {
      if (
        this.isEditing &&
        this.goal &&
        this.goal.subAreaId !== null &&
        this.goal.subAreaDesc !== null
      ) {
        this.selectedSubArea = {
          id: this.goal.subAreaId,
          name: this.goal.subAreaDesc,
        };
      } else {
        this.selectedSubArea = null;
      }
    },
  },
  async mounted() {
    this.loadEditing();
    if (this.goal) {
      this.currentGoal = this.goal;
      this.description = this.goal.spaLongDescription;
      this.selectedStrengthOrNecessity = !this.goal?.strenghtsAndNecessities ? [] : [...this.goal.strenghtsAndNecessities];
    }
  },
  async created() {
    Object.keys(rules).forEach((rule) => {
      const ruleObj = {
        ...rules[rule],
        message: messages[rule]
          ? messages[rule].replace('{_object_}', 'de la meta')
          : '',
      };
      extend(rule, ruleObj);
    });
    this.currentGoal = this.goal;
    this.description = this.goal.spaLongDescription;
    this.selectedStrengthOrNecessity = !this.goal?.strenghtsAndNecessities ? [] : [...this.goal.strenghtsAndNecessities];
  },
  watch: {
    selectedSubArea(_, oldValue) {
      if (!oldValue) return;
      
      this.selectedStrengthOrNecessity = [];
    },
    description(newValue) {
      this.$emit('pending-change', this.hasCreationPendingChange);
    },
    'selectedSubArea.id'(newValue) {
      this.$emit('pending-change', this.hasCreationPendingChange);
    },
    selectedStrengthOrNecessity(newValue, oldValue) {
      this.skillsUpdated = JSON.stringify(newValue) != JSON.stringify(oldValue);
      this.$emit('pending-change', this.hasCreationPendingChange);
    },
  },
  computed: {
    completeDescription() {
      const description = !this.description ? '' : FirstLetterToUpperCase(this.description);
      let adequacyText = !this.showAdequacy ? '' : BuildAdequacyText(this.adequacyData);

      if (!adequacyText)
        return `${description}.`;

      adequacyText = FirstLetterToUpperCase(adequacyText);
      return `${description}. ${adequacyText}.`;
    },
    hasCreationPendingChange() {
      if (!!this.currentGoal?.id)
        return false;

      return !!this.description || !!this.selectedSubArea?.id || this.skillsUpdated;
    }
  },
};
</script>

<style scoped></style>
